import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { usePublishCampaign } from './usePublishCampaign'

export type PublishCampaignModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  givingCampaign: {
    id: string
    title: string
  } | null
  onSuccess: () => void
  onError: (error?: Record<'code' | 'message' | 'title', string>) => void
}>

export function PublishCampaignModal({
  isOpen,
  handleClose,
  givingCampaign,
  onSuccess,
  onError
}: PublishCampaignModalProps) {
  const { t } = useTranslation()

  const { isLoading, publishCampaign } = usePublishCampaign({
    campaignId: givingCampaign?.id,
    onPublished: onSuccess,
    onError
  })

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <ActionModal
        title={t('typography.givingCampaigns.publishCampaign.title')}
        primaryButtonText={t('typography.givingCampaigns.publishCampaign.button')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={publishCampaign}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.givingCampaigns.publishCampaign.description"
          components={{ b: <b /> }}
          values={{ campaignName: givingCampaign?.title ?? '' }}
        />
      </ActionModal>
    </Modal>
  )
}
